import { Component, inject } from '@angular/core';
import { ShoppingCartService } from 'src/services/shoppingcart.service';

export interface Tab {
  label: string;
  route: string[];
}

@Component({
    selector:    'checkout-tab-bar',
    templateUrl: './checkout-tab-bar.component.haml',
    styleUrls:   ['./checkout-tab-bar.component.sass'],
    standalone:  false
})
export class CheckoutTabBarComponent {
  private shoppingCartService = inject(ShoppingCartService);

  tabs: Tab[] = [
    {
      label: 'Produkte',
      route: ['/checkout', 'products']
    },
    {
      label: 'Kunden',
      route: ['/checkout', 'members']
    },
    {
      label: 'Warenkörbe',
      route: ['/checkout', 'shopping-carts']
    },
  ];

  onTabClick(tab: Tab, isActive: boolean): void {
    const target = tab.route.at(-1);
    if (target === 'products' && isActive)
      this.shoppingCartService.cartId = null;
  }
}
